import { Button, Divider, InputNumber, Row, Space } from 'antd';
import { useCallback, useContext, useMemo } from 'react';

import { useWindowSize } from '@app/hooks';
import {
  CHF_MAX_SERVICES_COST,
  CHF_MIN_SERVICES_COST,
  CHF_VISITS_FILTER,
} from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { ClientFiltersContext } from '@app/providers';

import { hideFilterBlock } from '@pages/Clients/ClientsList/utils';

export const VisitsServicesSum = ({
  filterGroupIndex,
}: {
  filterGroupIndex: number;
}) => {
  const {
    filters,
    handleDisabling,
    setUpServerDataChunk,
    onChangeFiltersHandler,
  } = useContext(ClientFiltersContext);
  const { innerWidth } = useWindowSize();
  const { MinServicesCost, MaxServicesCost } = useMemo(
    () => filters.VisitsFilter[filterGroupIndex]?.Values?.[0],
    [filters, filterGroupIndex]
  );

  const onChangeHandler = useCallback(
    (type: 'MinServicesCost' | 'MaxServicesCost') => (value: number | null) => {
      onChangeFiltersHandler('VisitsFilter', filterGroupIndex, type, value);
    },
    [filterGroupIndex, onChangeFiltersHandler]
  );

  const onKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === '-' || event.key === '+') {
        event.preventDefault();
      }
    },
    []
  );
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Space>
        <InputNumber
          controls={false}
          addonBefore="от"
          style={{ width: '120px' }}
          type="number"
          value={MinServicesCost}
          onChange={onChangeHandler('MinServicesCost')}
          onKeyDown={onKeyDown}
        />
        <InputNumber
          controls={false}
          addonBefore="до"
          style={{ width: '120px' }}
          type="number"
          value={MaxServicesCost}
          onChange={onChangeHandler('MaxServicesCost')}
          onKeyDown={onKeyDown}
        />
      </Space>
      <Divider style={{ marginTop: '8px', marginBottom: '12px' }} />
      <Row justify="end">
        <Button
          type="primary"
          size="small"
          disabled={handleDisabling(
            CHF_VISITS_FILTER,
            CHF_MIN_SERVICES_COST,
            true,
            CHF_MAX_SERVICES_COST,
            filterGroupIndex
          )}
          onClick={() => {
            setUpServerDataChunk(
              CHF_VISITS_FILTER,
              CHF_MIN_SERVICES_COST,
              true,
              CHF_MAX_SERVICES_COST,
              filterGroupIndex
            );

            hideFilterBlock(
              '.visits-services-sum-label',
              innerWidth,
              filterGroupIndex
            );
          }}
        >
          Выбрать
        </Button>
      </Row>
    </div>
  );
};
